import { useEffect, useState } from "react";
import Modal from "../../common/Modal";
import { Ally, Tour } from "../../../types/common.types";
import { useAdmin } from "../../../context/admin";
import { useGlobal } from "../../../context/global";
import AdminService from "../../../services/admin.service";
import { AiOutlineCloseCircle } from "react-icons/ai";
import styled from "styled-components";
import { mobile } from "../../../styles/responsive";
import GeneralInput from "../../common/GeneralInput";

export default function AllyInfo() {
    const { setIsLoading } = useGlobal()
    const { allyInfoId, setAllyInfoId } = useAdmin()
    const [ally, setAlly] = useState<Ally>()
    const [tours, setTours] = useState<Tour[]>([])

    useEffect(() => {
        async function getModalInfo() {
            setIsLoading(true)
            try {
                const response = await (await AdminService.getAlly(allyInfoId!)).data
                const toursResponse = await (await AdminService.listTours()).data
                console.log(response)
                setAlly(response)
                setTours(toursResponse)
            } catch (error) {
                console.error("Error fetching ally info:", error)
            } finally {
                setIsLoading(false)
            }
        }
        getModalInfo()
    }, [allyInfoId])

    return (
        <Modal>
            <h2>Ally Information</h2>
            <div className="close" title="close"
                onClick={() => {
                    setAllyInfoId(undefined)
                }}
            >
                <AiOutlineCloseCircle/>
            </div>
                <Main>
                    {
                        tours.map((item, idx: number) => {
                            return (
                                <div className="card-container">
                                    <div className="card" key={idx}
                                    >
                                        <h3 className="card__title">
                                            {item.id}
                                        </h3>
                                        <p className="card__content">
                                            Tour ID: {item.id}
                                        </p>
                                        <GeneralInput
                                        label={`Price for ${item.id}`}
                                        type="number"
                                        value={ally?.tour_prices?.find(tp => tp.tour_id === item.id)?.price || 0}
                                        onChange={async (e) => {
                                            const newPrice = parseFloat(e.target.value)
                                            if (ally) {
                                                const newItem = ally.tour_prices.some(tp => tp.tour_id === item.id) ? ally.tour_prices.map(tp => {
                                                    if (tp.tour_id === item.id) {
                                                        return {
                                                            ...tp,
                                                            price: newPrice
                                                        }
                                                    }
                                                    return { ...tp }
                                                }) : [...ally.tour_prices, {id: '', tour_id: item.id, ally_id: ally.id, price: newPrice, created_at: new Date()}]
                                                setAlly({
                                                    ...ally,
                                                    tour_prices: newItem
                                                })
                                                
                                            }
                                        }}
                                        />
                                        <button type="button"
                                        style={{ padding: '5px 10px'}}
                                        onClick={async () => {
                                            if (!ally) return
                                            setIsLoading(true)
                                            try {
                                                const tourPrice = ally.tour_prices.find(t => t.tour_id === item.id)?.price
                                                if (!tourPrice) return
                                                await AdminService.handleTourPriceChange(ally.id, item.id, tourPrice)
                                            } catch (error) {
                                                console.error("Error updating tour price:", error)
                                            } finally {
                                                setIsLoading(false)
                                            }
                                        }}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            )
                        })
                    }
                </Main>
        </Modal>
    )
}


const Main = styled.section`
display: grid;
grid-template-columns: repeat(2, minmax(200px, 1fr));
${mobile({
    gridTemplateColumns: '1fr'
})}
gap: 20px;
.card-container {
    position: relative;
    > button {
        z-index: 10;
        position: absolute;
        border-radius: 10px;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all ease-in-out 0.2s;
        cursor: pointer;
        font-size: 18px;
        color: ${props => props.theme.white};
    }
    > button.edit {
        border: 2px solid ${props => props.theme.blueLight};
        background-color: ${props => props.theme.blueLight};
        right: 50px;
        top: 10px;
    }
    > button.edit:hover {
        background-color: ${props => props.theme.blue};
    }
    > button.delete {
        background-color: ${props => props.theme.lightRed};
        border: 2px solid ${props => props.theme.lightRed};
        right: 10px;
        top: 10px;
    }
}
.card {
    font-family: "Arial";
    padding: 1rem;
    cursor: pointer;
    border-radius: 0.75rem;
    background: ${props => props.theme.whiteBackground};
    box-shadow: 0px 8px 16px 0px rgb(0 0 0 / 3%);
    position: relative;
    overflow: hidden;
}

.card > * + * {
    margin-top: 1.1em;
}

.card .card__content {
    color: var(--secondary-color);
    font-size: 0.86rem;
}

.card .card__title {
    padding: 0;
    font-size: 1.3rem;
    font-weight: bold;
}

.card .card__date {
    color: #6e6b80;
    font-size: 0.8rem;
}

.card .card__arrow {
    position: absolute;
    background: ${props => props.theme.blue};
    padding: 0.4rem;
    border-top-left-radius: 0.75rem;
    border-bottom-right-radius: 0.75rem;
    bottom: 0;
    right: 0;
    transition: 0.2s;
    display: flex;
    justify-content: center;
    align-items: center;
}

.card svg {
    transition: 0.2s;
}

.card:hover .card__title {
    color: ${props => props.theme.blue};
    text-decoration: underline;
}

.card:hover .card__arrow {
    background: ${props => props.theme.blueDark};
}

.card:hover .card__arrow svg {
    transform: translateX(3px);
}
`